/**
 * True when `pathname` is the given `route` or a path nested under it. Matches
 * full path segments only, so `/manage` does not match `/manage-extra`.
 */
export const isRoutePathname = ({
  pathname,
  route,
}: {
  pathname: string
  route: string
}) => pathname === route || pathname.startsWith(`${route}/`)
